import Vue from 'vue';
import {
 variables,
 apiEndPointLead,
 apiEndPointExStudent,
} from './includes/data';
import { metodos } from './includes/methods';
import '../plugins/vee-validate';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/es';
import VueFormWizard from 'vue-form-wizard';
import VueTheMask from 'vue-the-mask';
import axios from 'axios';

Vue.use(VueTheMask);
Vue.use(ElementUI, { locale });
Vue.use(VueFormWizard);

if (document.getElementById('app-clases-prueba')) {
 // Vue click outside
 const buttons = document.querySelectorAll('#calendar-test');
 for (let i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener('click', function () {
   appPrueba.modalClasePrueba = true;
  });
 }

 // Selección de sucursal
 metodos.selectedBranch();

 // Selección de categoria
 metodos.selectedCategory();

 // Selección de edad
 metodos.selectedAge();

 var appPrueba = new Vue({
  el: '#app-clases-prueba',
  data: function () {
   return {
    modalClasePrueba: false,
    viewTable: false,
    viewFormClass: false,
    variables: variables,
    metodos: metodos,
   };
  },
  async created() {
   this.variables.classSwimming = await fetch(
    'https://app.jackrabbitclass.com/jr3.0/Openings/OpeningsJson?OrgId=507873&Status=Active&Sort=start_time ASC'
   )
    .then((response) => response.json())
    .then((response) => response.rows);
   this.variables.classBackUp = JSON.parse(
    JSON.stringify(this.variables.classSwimming)
   );
  },
  methods: {
   displayAge() {
    this.variables.viewExperience = false;
    if (this.variables.categoryPriceMB) {
     this.variables.viewKids1 = true;
     this.metodos.displayAgeCategory1();
    } else if (this.variables.category) {
     this.variables.viewQuestion = false;
     this.variables.viewLevel = true;
    } else if (this.variables.viewAgeSelected1) {
     this.metodos.displayKids1();
    } else if (this.variables.viewAgeSelected2) {
     this.metodos.displayKids2();
    } else if (this.variables.viewAgeSelected3) {
     this.metodos.displayAdults();
    } else {
     this.variables.viewAge = true;
     this.variables.question = '¿Qué edad tienes?';
    }
   },
   displayFormAdults() {
    window.open('https://form.jotform.com/220234682543048');
    this.closeDialog();
   },
   preloadClass(link, name, startTime, endTime) {
    this.variables.name = name;
    this.variables.time = startTime + '-' + endTime;
    let searchParams = new URLSearchParams(link);
    this.variables.idClass = searchParams.get('amp;preLoadClassID');
    this.viewTable = false;
    this.viewFormClass = true;
   },
   selectedBranch(selectedSucursal) {
    this.variables.classSwimming = this.variables.classSwimming.filter(
     (sucursal) => sucursal.location_name == selectedSucursal
    );
    this.variables.viewLevel = false;
    this.viewTable = true;
   },
   closeDialog() {
    this.modalClasePrueba = false;
    this.viewFormClass = false;
    this.viewTable = false;
    this.variables.classSwimming = JSON.parse(
     JSON.stringify(this.variables.classBackUp)
    );
    this.variables.sucursales.length = 0;
    this.variables.viewQuestion = true;
    this.variables.question = '¿Has nadado en Cañada?';
    this.variables.category = '';
    this.variables.level = '';
    this.variables.countSelected = 0;
    this.variables.ageRange = null;
    this.variables.ageError = false;
    this.variables.ageError2 = false;
    this.variables.idClass = '';
    this.variables.name = '';
    this.variables.time = '';
    this.variables.viewExperience = true;
    this.variables.viewAge = false;
    this.variables.viewKids1 = false;
    this.variables.viewCategory1 = false;
    this.variables.viewAgeCategory1 = false;
    this.variables.viewKids2 = false;
    this.variables.viewKids3 = false;
    this.variables.viewAdults = false;
    this.variables.viewLevel = false;
    this.variables.viewFormStudent = false;
    this.variables.category = '';
    this.variables.level = '';
    this.variables.filtroDia = 'mon';
    this.variables.sucursalPage = '';
    this.variables.categoryPriceMB = false;
    this.variables.viewAgeSelected1 = false;
    this.variables.viewAgeSelected2 = false;
    this.variables.viewAgeSelected3 = false;
    this.variables.sendData = false;
    this.variables.family.name = '';
    this.variables.family.last_name = '';
    this.variables.family.email = '';
    this.variables.family.confirm_email = '';
    this.variables.family.phone = '';
    this.variables.student.name = '';
    this.variables.student.last_name = '';
    this.variables.student.gender = '';
    this.variables.student.birthday = '';
    this.variables.student.aviso = '';
    this.variables.exstudent.name = '';
    this.variables.exstudent.last_name = '';
    this.variables.exstudent.email = '';
    this.variables.exstudent.phone = '';
    this.variables.exstudent.level = '';
    this.variables.exstudent.place = '';
   },
   selectedBranchSucursales() {
    this.variables.classSwimming = this.variables.classSwimming.filter(
     (sucursal) => sucursal.location_name == this.variables.sucursalPage
    );
    this.variables.viewLevel = false;
    this.viewTable = true;
   },
   displayFormStudent() {
    this.variables.viewQuestion = false;
    this.variables.viewExperience = false;
    this.variables.viewFormStudent = true;
   },
   onSubmitContact() {
    this.$refs.contact.validate().then((success) => {
     if (success) {
      this.$refs.wizard.nextTab();
     }
    });
   },
   onSubmitStudent() {
    this.$refs.student.validate().then((success) => {
     if (success) {
      this.variables.sendData = true;
      this.sendDataFamily();
     }
    });
   },
   onSubmitExStudent() {
    this.$refs.exStudent.validate().then((success) => {
     if (success) {
      this.variables.sendData = true;
      this.sendDataExStudent();
     }
    });
   },
   async sendDataFamily() {
    var object = {};
    object['id_class'] = this.variables.idClass;
    object['family'] = this.variables.family;
    object['student'] = this.variables.student;
    object['info_class'] = this.variables.name + ' ' + this.variables.time;
    await axios
     .post(apiEndPointLead, object)
     .then((result) => {
      console.log(result);
      this.variables.sendData = false;
      this.$refs.wizard.nextTab();
     })
     .catch((error) => {
      console.log(error);
     });
   },
   async sendDataExStudent() {
    var object = {};
    object['name'] = this.variables.exstudent.name;
    object['last_name'] = this.variables.exstudent.last_name;
    object['email'] = this.variables.exstudent.email;
    object['phone'] = this.variables.exstudent.phone;
    object['level'] = this.variables.exstudent.level;
    object['place'] = this.variables.exstudent.place;
    await axios
     .post(apiEndPointExStudent, object)
     .then((result) => {
      console.log(result);
      this.variables.sendData = false;
      this.$refs.wizard.nextTab();
     })
     .catch((error) => {
      console.log(error);
     });
   },
  },
 });
}
